import Vue from "vue";
import _ from "lodash";
import store from '../../../../stores/application/index.js.erb'

class EffContractServices {
    static calculatePlanWithBid(listEffContracts, changeEffContracts, bid, key) {
        const index = listEffContracts.indexOf(changeEffContracts)
        const newPlan = ((Number(changeEffContracts.plan) * bid).toFixed(2)).toString();
        store.commit('effective_contract/updateValueWithKeyList', {
            list: listEffContracts,
            index: index,
            key: key,
            value: newPlan,
        })
    }

    static calculatePlanDescriptionWithBid(listEffContracts, changeEffContracts, bid, key) {
        const index = listEffContracts.indexOf(changeEffContracts)
        const newDescription = changeEffContracts.plan_description.replace(/[0-9]+/g,
            (Number(changeEffContracts.plan) * bid).toFixed(2)
        );
        store.commit('effective_contract/updateValueWithKeyList', {
            list: listEffContracts,
            index: index,
            key: key,
            value: newDescription,
        })
    }

    static calculatePlanPersonEffConWithBid(listEffContracts, changePersonEffCon, bid, key) {
        const index = listEffContracts.indexOf(changePersonEffCon)
        const newPlan = ((Number(changePersonEffCon.eff_contract.plan) * bid).toFixed(2)).toString();
        Vue.set(listEffContracts[index].eff_contract, key, newPlan);
    }

    static findContractsDependentOnBid(listEffContracts) {
        const publicationBasic = "Публикационная активность: статьи, тезисы, индексируемые в РИНЦ; статьи, входящие в список ВАК, имеющие DOI";
        const incomeStimulating = "Доход АмГУ от НИР, НИОКР, привлеченный работником";
        const publicationStimulating = "Публикационная активность: статьи, материалы конференций, индексируемыеWeb of Science, Scopus; статьи в журналах, входящих в Перечень ВАК, имеющие DOI"

        return _.filter(listEffContracts, (i) => {
            return  (
                i.indicator_name ===  publicationBasic
                || i.indicator_name === incomeStimulating
                || i.indicator_name === publicationStimulating
            )
        });
    }

    static findPersonContractsDependentOnBid(listPersonEffContracts) {
        const publicationBasic = "Публикационная активность: статьи, тезисы, индексируемые в РИНЦ; статьи, входящие в список ВАК, имеющие DOI";
        const incomeStimulating = "Доход АмГУ от НИР, НИОКР, привлеченный работником";
        const publicationStimulating = "Публикационная активность: статьи, материалы конференций, индексируемыеWeb of Science, Scopus; статьи в журналах, входящих в Перечень ВАК, имеющие DOI"

        return _.filter(listPersonEffContracts, (personContract) => {
            return  (
                personContract.eff_contract.indicator_name ===  publicationBasic
                || personContract.eff_contract.indicator_name === incomeStimulating
                || personContract.eff_contract.indicator_name === publicationStimulating
            )
        });
    }
}

export default EffContractServices